import { gql } from '@apollo/client';
import { PROJECT_CONTRIBUTOR_FRAGMENT } from 'components/assetFeed/gql/fragments.graphql';

export default gql`
  fragment ProjectTaskFragment on ProjectTask {
    id
    completed
    completedAt
    completedBy {
      id
      name
    }
    createdBy {
      id
      name
    }
    details
    lastUpdatedBy {
      id
      name
    }
    position
    updatedAt
    images {
      id
      databaseId
      assetPreviewThumbnail
      assetPreviewLarge
      contributor {
        ... on ProjectContributorInterface {
          ...ProjectContributorFragment
        }
      }
      originalUris(variants: [ORIGINAL, MEDIUM, THUMBNAIL]) {
        __typename
        variant
        uri
      }
      capturedAt
      project {
        __typename
        databaseId
        formattedLine1
        formattedLine2
        id
      }
      projectInfo {
        __typename
        databaseId
        formattedLine1
        formattedLine2
        id
      }
    }
    videos {
      id
      databaseId
      assetPreviewThumbnail
      assetPreviewLarge
      playbackUrl
      contributor {
        ... on ProjectContributorInterface {
          ...ProjectContributorFragment
        }
      }
      capturedAt
      project {
        __typename
        databaseId
        formattedLine1
        formattedLine2
        id
      }
      projectInfo {
        __typename
        databaseId
        formattedLine1
        formattedLine2
        id
      }
    }
  }
  ${PROJECT_CONTRIBUTOR_FRAGMENT}
`;
